import { render, staticRenderFns } from "./ExtrasSelection.vue?vue&type=template&id=131d0808"
import script from "./ExtrasSelection.vue?vue&type=script&lang=js"
export * from "./ExtrasSelection.vue?vue&type=script&lang=js"
import style0 from "./ExtrasSelection.vue?vue&type=style&index=0&id=131d0808&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports